import {useRef} from 'react';

import aiAssistantVoiceLevelService from '../services/aiAssistant/aiAssistantVoiceLevelService';
import aiAssistantWaveformMotionService from '../services/aiAssistant/aiAssistantWaveformMotionService';
import useAnimationLoop from './useAnimationLoop';

// Writes each strand's path every frame. Returns the ref for the <g> holding the strands
const useAiAssistantWaveform = () => {
    const strandsRef = useRef(null);

    useAnimationLoop(() => {
        const strands = [...strandsRef.current.children];
        let timeS = 0;

        return (frameS) => {
            const level = aiAssistantVoiceLevelService.getLevel();

            // Integrated, so a pace change continues from the current pose
            timeS += frameS * aiAssistantWaveformMotionService.getLevelPace(level);

            aiAssistantWaveformMotionService
                .getWaveformFrame(timeS, level)
                .forEach((path, index) => strands[index].setAttribute('d', path));
        };
    });

    return strandsRef;
};

export default useAiAssistantWaveform;
